// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

let firebaseConfig;
export let discordClientID;
export let isProd;

if (window.location.href.indexOf('pandemic-eve.web.app') !== -1) {
  firebaseConfig = {
    apiKey: "AIzaSyCZYYzO3peg_MvBkf49L_1CZ_r2gS2oOfw",
    authDomain: "pandemic-eve.firebaseapp.com",
    databaseURL: "https://pandemic-eve.firebaseio.com",
    projectId: "pandemic-eve",
    storageBucket: "pandemic-eve.appspot.com",
    messagingSenderId: "720487641839",
    appId: "1:720487641839:web:3095edf09b77ddd112e11a"
  };
  isProd = true;
  discordClientID = "1048328336264400956";  // Panda Master bot for PEGN
} else {
  firebaseConfig = {
    apiKey: "AIzaSyBG6F62ok_TudaCifOOYR4QycfxBuzbgIQ",
    authDomain: "caylus-eve-dev.firebaseapp.com",
    databaseURL: "https://caylus-eve-dev.firebaseio.com",
    projectId: "caylus-eve-dev",
    storageBucket: "caylus-eve-dev.appspot.com",
    messagingSenderId: "353364140226",
    appId: "1:353364140226:web:cccfad6662ab7dacdd9b5b"
  };
  discordClientID = "749064008161558588";
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// Required for side-effects
require("firebase/firestore");
require("firebase/functions");
require("firebase/auth");

// Connect to emulators if running locally - must be done before creating database instance
if (window.location.hostname === 'localhost') {
  console.log('🔧 Connecting to Firebase emulators...');
  firebase.firestore().settings({
    host: 'localhost:8080',
    ssl: false,
    experimentalForceLongPolling: true
  });
  firebase.functions().useFunctionsEmulator('http://localhost:5001');
}

if (window.location.href.indexOf('lvh.me') !== -1) {
  firebase.functions().useFunctionsEmulator("http://lvh.me:5001")
}

export var database = firebase.firestore();
export var functions = firebase.functions();

const MILLION = 1000000;

export var globalSettings = {
  disableAuthentication: window.location.hostname === 'localhost', // disable for local development
  hardcodedUserId: "376528898504261633", //updated to fortmana ID, was 234791348232781827
  disableRoleFetch: false,
  pandacoinRatio: 0,  // proportion of buyback that is always granted in Pandacoin
  orePriceMultiplier: 0.95, // multiplier of value of minerals used to calculate price of ore
  // refinePaymentRatio: 0.01,  // ratio of total value of refined ores paid to refiner
  // "demand ratio" is inventory / target
  highDemandRatio: 1.0,
  lowDemandRatio: 2.0,
  veryLowDemandRatio: 5.0,
  noDemandRatio: 10.0,
  // noDemandRatio: 6/3,
  highDemandMultiplier: 1.0, // ratio < highDemandRatio
  mediumDemandMultiplier: 1.0, // highDemandRatio < ratio < lowDemandRatio
  lowDemandMultiplier: 1.0, // ratio > lowDemandRatio
  veryLowDemandMultiplier: 1.0, // ratio > veryLowDemandRatio
  noDemandMultiplier: 1.0,  // target = 0
  maxDemandRatio: 2.0,  // max of displayed progress bar. no effect on prices beyond "low" demand
  // defaultOrderLimit: 100 * MILLION,  // max pending orders placed per pilot, *beyond* their ISK/Panda balance
  transactionLimitPerDay: 50 * MILLION,  // max transaction value per pilot per day
  //Adjusting price ratios to slim margins
  purchasePriceMaterialCostRatio: 1.1,  // multiplier for price of ships based on material (mineral, PI) cost // previously 1.10
  purchasePriceFixedCostRatio: 1.05,  // multiplier for price of ships based on fixed production cost  // previously 1.09
  purchasePriceBlueprintCostRatio: 1.10, // multiplier for price of ships based on estimated blueprint cost  // previously 1.2
  // engineerPaymentProfitMarginRatio: 0.15,  // ratio of ship profit margin paid to engineer
  engineerPaymentMaterialCostRatio: 0.0,
  shipMaterialEfficiency: 1.04 / 1.5,
  shipTypes: ['frigate', 'destroyer', 'cruiser', 'battlecruiser', 'battleship', 'industrial', 'module', 'capital'],
  // assumed ship efficiency for building. 1.5 requires because worst efficiency is stored in database.
  // 5/4/0 = 1.04, 5/5/0 = 1.00, each level of expert -0.01
  // Nov 2023: Added efficiency improvements based on citadel updates, previously .97
  // should make ship building way cheaper for corp
  shipTypeToMaterialEfficiency: {
    frigate: 0.86,
    destroyer: 0.86,
    cruiser: 0.86,
    battlecruiser: 0.86,
    battleship: 0.86,
    industrial: 0.86,
    module: 0.84,        // Capital component materials use 84% efficiency
    component: 0.84,     // Alias for capital component material efficiency
    unknown: 0.86,
    // Capital ship component count efficiencies (varies by ship type)
    Dreadnoughts: 0.82,
    Carriers: 0.82,
    'Force Auxiliaries': 0.82,
    Freighters: 0.82,
    'Jump Freighters': 0.82,
    'Capital Industrial Ship': 0.82,
    Lancer: 0.82,
    'Tactical Carrier': 0.90,
    Supercarrier: 0.77,
    'Versatile Assault': 0.77,
    capital: 0.82,       // Default for unknown capital types
  },
  // Capital component production cost discount (from skills)
  componentProductionCostDiscount: 0.20,  // 20% discount on component production costs
  hideRecipesUnlessAdmin: false,
  hideQueueUnlessAdmin: false,
  hideTransactionUnlessAdmin: false,
  hideDatacoresUnlessAdmin: false,
  hideDebrisUnlessAdmin: false,
  enableBuildAndDeliver: true,
  locations: {
    '85-B52': '85- Triangle',
    'VFK-IV': 'VFK-IV',
    'Jita': 'Jita ITC',
    'CCP-US': 'CCP-US',
    'RO0-AF': 'RO0-AF',
    //'Onnamon': 'Onnamon ITC',
    //'PAND-CZDJ': 'CZDJ-1 X',
    //'Ned': 'Ned',
    //'MO-GZ5': 'MO-GZ5',    //'3T7-M8': '3T7-M8 Garrison',
    //'5S-KXA': '5S-KXA Skunk Works',
    // 'O-2RNZ': 'O-2RNZ Botany Bay'
    // 'PAND-3JN9': 'Pandemic: 3JN9-Q XII (CLOSING SOON)',
    // 'PAND-Masalle': '[CLOSED] Pandemic: Masalle VII',
    // 'PAND-Pemene': 'Pandemic: Pemene VI (high-sec base)',
    // 'VIRI-CZDJ': 'Virion: CZDJ-1 X (alliance HQ)',
    // 'VIRI-3JN9': 'Virion: 3JN9-Q XII (mining base)',
    // 'VIRI-Masalle': '[CLOSED] Virion: Masalle VII',
    // 'VIRI-Pemene': 'Pemene VI - Moon 10 (CLOSING SOON)',
  },
  defaultLocation: '85-B52',
  defaultLocationShipOrders: '85-B52',
  allowShipOrdersAt: ['85-B52'],
  allowTransactionsAt: ['85-B52','VFK-IV', 'Jita', 'CCP-US', 'RO0-AF'],
  locationToTargetMultiplier: {
    '': 1.0,
    '85-B52': 1.0,
    'VFK-IV': 1.0,
    'Jita': 0.8,
    'CCP-US': 1.0,
    'RO0-AF': 1.0,
  },
  locationToPriceMultiplier: {
    '': 1.0,
    '85-B52': 1.0,
    'VFK-IV': 1.0,
    'Jita': 0.8,
    'CCP-US': 1.0,
    'RO0-AF': 1.0,
  },
  structureMaterials: [
      'Construction Blocks',
      'Silicate Glass',
      'Supertensile Plastics',
      'Smartfab Units',
      'Coolant',
      'Reactive Gas',
      'Polyaramids',
      'Industrial Fibers',
      'Nanites',
      'Condensates',
      'Noble Gas',
  ]
};
